import styled from '@emotion/styled';
import type { ReactNode } from 'react';
import { claudeTokens } from '../theme';
import { UI_ACTION_ATTR } from '@/common/uiEventNames';

const Wrap = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 12px;
    min-height: 28px;
    margin-bottom: var(--home-heading-gap, 14px);

    @media (max-width: 768px) { margin-bottom: var(--home-heading-gap, 10px); }
`;

const Heading = styled.div`
    display: flex;
    align-items: baseline;
    min-width: 0;
    gap: 8px;
`;

const Title = styled.h2`
    font-family: ${claudeTokens.font.heading};
    font-weight: 700;
    font-size: 20px;
    line-height: 1.4;
    word-break: keep-all;
    color: ${claudeTokens.color.text1};
    margin: 0;

    @media (max-width: 768px) {
        font-size: 18px;
    }
`;

const MoreLink = styled.button`
    border: 0;
    background: none;
    padding: 4px 8px;
    flex-shrink: 0;
    font-family: ${claudeTokens.font.body};
    font-size: 13px;
    font-weight: 500;
    color: ${claudeTokens.color.accent};
    text-decoration: none;
    cursor: pointer;
    white-space: nowrap;

    &:focus-visible { outline: 2px solid ${claudeTokens.color.accent}; outline-offset: 3px; }

    &:hover {
        text-decoration: underline;
        color: ${claudeTokens.color.accentDark};
    }
`;

interface Props {
    title: string;
    moreLabel?: string;
    onMoreClick?: () => void;
    meta?: ReactNode;
}

export default function SectionHeader({ title, moreLabel = '전체보기', onMoreClick, meta }: Props) {
    return (
        <Wrap>
            <Heading><Title>{title}</Title>{meta}</Heading>
            {/* data-ui-action: 홈 섹션 "더보기" 클릭 기록(useUiScope) */}
            {onMoreClick && <MoreLink type="button" {...{ [UI_ACTION_ATTR]: 'more' }} onClick={onMoreClick}>{moreLabel}</MoreLink>}
        </Wrap>
    );
}
